import {
  switchMap,
  catchError,
  mergeMap,
} from 'rxjs/operators';
import {
  Observable,
  of,
  from,
} from 'rxjs';
import { ofType } from 'redux-observable';
import { UserInfo } from '../../shared/models/user';
import UserService from '../../technicians/services/user.service';
import {
  ProfileActions,
  ProfileAction,
  LoadUserProfileInfo,
  LoadUserProfileInfoSucceed,
  LoadUserProfileInfoFailed,
  UpdateUserProfileInfo,
  UpdateUserProfileInfoFailed,
  UpdateUserProfileInfoSucceed,
  UpdateUserInfo,
  UpdateUserInfoSucceed,
  UpdateUserInfoFailed,
} from '../actions/profile.action';
import { CreateErrorNotice, CreateSuccessNotice } from '../../store/actions/toaster.action';
import { ServerErrorMessages } from '../../shared/utils/server-error-utils';
import { SendGTMEvent } from '../../store/actions/tagManager.action';
import { LoadOrg } from '../../store/actions/orgHierarchy.action';

export const getProfileEpic = ($action: Observable<ProfileAction>) => $action.pipe(
  ofType<LoadUserProfileInfo>(ProfileActions.LoadUserProfileInfo),
  switchMap((action) => from(UserService.getUserInfo()).pipe(
    mergeMap((data: UserInfo) => {
      const result = [
        new LoadUserProfileInfoSucceed(data),
        new LoadOrg(data.orgId),
      ] as any;
      if (action?.payload?.isLoadAfterLogin) {
        result.push(new SendGTMEvent({
          event: action?.payload?.event,
          org_id: data?.orgId,
          user_id: data?.id,
          roles: data?.roles
        }));
      }
      return of(...result);
    }),
    catchError((error: Error) => of(new LoadUserProfileInfoFailed(ServerErrorMessages[error.message] || 'Unknown user loading error!'))),
  )),
);

const updateProfileEpic = ($action: Observable<ProfileAction>) => $action.pipe(
  ofType<UpdateUserProfileInfo>(ProfileActions.UpdateUserProfileInfo),
  switchMap((action) => from(UserService.updateProfileUser(action.payload.userId, action.payload.body)).pipe(
    mergeMap((user) => of(
      new UpdateUserProfileInfoSucceed(user),
      new CreateSuccessNotice('Success', 'User profile information updated'),
    )),
    catchError((error: Error) => of(
      new UpdateUserProfileInfoFailed(ServerErrorMessages[error.message] || 'Failed to update user profile'),
      new CreateErrorNotice('Error', 'Failed to update user profile'),
      ),
    )),
  ));

const updateAgentEpic = ($action: Observable<ProfileAction>) => $action.pipe(
  ofType<UpdateUserInfo>(ProfileActions.UpdateUserInfo),
  switchMap((action) => from(UserService.updateAgent(action.payload.userId, action.payload.body)).pipe(
    mergeMap((user) => of(
      new UpdateUserInfoSucceed(user),
      new CreateSuccessNotice('Success', 'User information updated'),
    )),
    catchError((error: Error) => of(
      new UpdateUserInfoFailed(ServerErrorMessages[error.message] || 'Failed to update user'),
      new CreateErrorNotice('Error', 'Failed to update user'),
      ),
    )),
  ));

const ProfileEpics = [
  getProfileEpic,
  updateProfileEpic,
  updateAgentEpic
];

export default ProfileEpics;
